export class SaveModuleModel {
    primaryCategory: string;
    secondaryCategory: string;
    id: string;
    name: string;
}
